export const FOOTER_LABEL_FALLBACKS = {
  legalPolicies: 'Legal policies',
  cookies: 'Cookies',
  acceptableUse: 'Acceptable use',
  termsOfUse: 'Terms of use',
  socialMedia: 'Social media',
  privacy: 'Privacy',
  disclosurePolicy: 'Disclosure policy',
  manageCookies: 'Manage cookies',
  speakUp: 'Speak up'
};

export type FooterLabels = typeof FOOTER_LABEL_FALLBACKS;

export const buildFooterLabels = (
  translations: Record<string, string | { [key: string]: string }>
): FooterLabels => {
  const t = (key: string, fallback: string): string => {
    const value = translations[key];
    return typeof value === 'string' && value !== '' ? value : fallback;
  };

  return {
    legalPolicies: t(
      'globalFooter.legalPolicies',
      FOOTER_LABEL_FALLBACKS.legalPolicies
    ),
    cookies: t('globalFooter.cookies', FOOTER_LABEL_FALLBACKS.cookies),
    acceptableUse: t(
      'globalFooter.acceptableUse',
      FOOTER_LABEL_FALLBACKS.acceptableUse
    ),
    termsOfUse: t('globalFooter.termsOfUse', FOOTER_LABEL_FALLBACKS.termsOfUse),
    socialMedia: t(
      'globalFooter.socialMedia',
      FOOTER_LABEL_FALLBACKS.socialMedia
    ),
    privacy: t('globalFooter.privacy', FOOTER_LABEL_FALLBACKS.privacy),
    disclosurePolicy: t(
      'globalFooter.disclosurePolicy',
      FOOTER_LABEL_FALLBACKS.disclosurePolicy
    ),
    manageCookies: t(
      'globalFooter.manageCookies',
      FOOTER_LABEL_FALLBACKS.manageCookies
    ),
    speakUp: t('globalFooter.speakUp', FOOTER_LABEL_FALLBACKS.speakUp)
  };
};
